import { render } from "./PreschoolAssignmentEdit.vue?vue&type=template&id=27f6d91c&scoped=true&ts=true"
import script from "./PreschoolAssignmentEdit.vue?vue&type=script&lang=ts"
export * from "./PreschoolAssignmentEdit.vue?vue&type=script&lang=ts"

import "./PreschoolAssignmentEdit.vue?vue&type=style&index=0&id=27f6d91c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f6d91c"]])

export default __exports__